goog.provide("shadow.js.shim.module$dayjs$locale$hu");
goog.provide("module$shadow_js_shim_module$dayjs$locale$hu");
shadow.js.shim.module$dayjs$locale$hu = shadow.js.nativeProvides["dayjs/locale/hu"] = require("dayjs/locale/hu");
module$shadow_js_shim_module$dayjs$locale$hu.default = shadow.js.shim.module$dayjs$locale$hu;
